<script setup lang="ts">
import NoInputConfirmModal from '@/components/modal/NoInputConfirmModal.vue';
import type { VolunteerNoticeModalProps } from '@/stores/modal';
interface Emits {
  (e: 'confirm'): void;
}

const props = defineProps<VolunteerNoticeModalProps>();
const emit = defineEmits<Emits>();

const handleConfirm = () => {
  props.onConfirm(props.memId);
};

const reapplyMessage = `안녕하세요.<br><br>
정토회 국제지부입니다.<br><br>
지난 소임과 같은 소임을 신청해 주셨네요.<br>
감사합니다.<br>
곧 연락드리겠습니다.<br>
조금만 기다려 주세요.<br><br>
궁금한 사항이 있으시면 FAQ를 살펴본 후,<br>
추가 문의는 &quot;마이정토 - 마이페이지 - 문의하기&quot;에서<br>
1:1 문의를 하실 수 있습니다.<br><br>
건강하고 행복한 새 날 되세요.`;

const defaultMessage = `국제지부 봉사를 신청해 주셔서 고맙습니다.<br><br>
신청서 내용을 검토한 후 다시 안내 드리겠습니다.<br>
연락드릴 때까지 1-2개월 정도 소요될 예정입니다.<br><br>
&quot;신청현황&quot;에서 결과를 확인하실 수 있습니다.<br>
궁금한 사항이 있으면 FAQ를 살펴본 후,<br>
&quot;마이페이지 - 문의하기&quot;<br>
에서 질문해 주세요.`;

const message = computed(() => (props.isReapply ? reapplyMessage : defaultMessage));
</script>

<template>
  <NoInputConfirmModal
    title="봉사소임 신청완료"
    :message="message"
    modal-type="volunteer-notice"
    confirm-text="확인"
    :show-cancel="false"
    @confirm="handleConfirm"
    :is-submitting="props.isSubmitting"
  />
</template>
